import { render, staticRenderFns } from "./abnormalTable.vue?vue&type=template&id=0508337c"
import script from "./abnormalTable.vue?vue&type=script&lang=js"
export * from "./abnormalTable.vue?vue&type=script&lang=js"
import style0 from "./abnormalTable.vue?vue&type=style&index=0&id=0508337c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports